<template>
  <div v-if="servicesModelValue.length > 0"
       class="sub-title">{{ $t('space.services') }}
  </div>
  <div v-if="servicesModelValue.length > 0"
       class="flex flex-wrap">
    <div class="flex items-start w-1/2 mb-[12px]"
         v-for="service in servicesModelValue">
      <svg-icon name="check" size="20" class="mr-[4px] mt-[2px]"></svg-icon>
      <div class="flex flex-col">
                <span class="text-[16px] text-osn-dark-grey-00">
                  {{ service.name }}
                </span>
        <span class="text-[14px] text-osn-grey-01">
                  {{ service.description }}
                </span>
      </div>
    </div>
  </div>
</template>
<script setup
        lang="ts">

const servicesModelValue = defineModel('spaceServices', { type: Array, default: () => [] });


</script>
<style scoped
       lang="scss">

</style>
